import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import user from './modules/user'
import notifier from './modules/notifier'
import braintree from './modules/braintree'
//import transaction from './modules/transaction'
import fundex from './modules/fundex'
//import createLogger from '../assets/logger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const vuexPersist = new VuexPersist({
      key: 'proj_fundex',
      storage: window.localStorage
})

var store = new Vuex.Store({
  modules: {
    fundex,
    notifier,
    user,
    braintree,
//    transaction 
  },
  strict: debug,
  plugins: [vuexPersist.plugin] // debug ? [createLogger()] : []
})

//store.dispatch('skey')

export default store

